// Droits appliqués sur l'appareil: une écriture interdite au rôle (ou au module
// retiré à ce compte) n'est ni appliquée ni mise en file — elle est refusée
// comme le serveur la refuserait. Les tables ci-dessous reprennent les gardes
// du serveur (`require_roles` des routeurs, `require_module` de `api/v1/__init__.py`).
// Le serveur reste seul juge: ceci évite d'afficher comme fait ce qu'il refusera.

const PARC = ['SUPER_ADMIN', 'ADMIN_SOCIETE', 'LOGISTIQUE', 'MAINTENANCE'];
const CONVOIS = ['SUPER_ADMIN', 'ADMIN_SOCIETE', 'LOGISTIQUE'];
const FINANCE = ['SUPER_ADMIN', 'ADMIN_SOCIETE', 'LOGISTIQUE', 'CONTROLEUR_CARBURANT', 'GESTIONNAIRE_STATION'];
const FACTURES = [
  'SUPER_ADMIN', 'ADMIN_SOCIETE', 'LOGISTIQUE', 'MAINTENANCE', 'GESTIONNAIRE_STATION',
  'GERANT_STATION', 'AGENT_STATION', 'CONTROLEUR_CARBURANT',
];

// [motif de l'adresse, module exigé, rôles autorisés (null: tout rôle connecté), exceptions]
const REGLES = [
  [/^\/trucks(\/|$)/, 'trucks', PARC],
  [/^\/drivers(\/|$)/, 'drivers', PARC],
  [/^\/clients(\/|$)/, 'clients', null],
  [/^\/companies(\/|$)/, 'companies', PARC],
  [/^\/operations(\/|$)/, 'operations', CONVOIS],
  [/^\/orders(\/|$)/, 'orders', null],
  [/^\/trips(\/|$)/, 'trips', null],
  [/^\/stock(\/|$)/, 'stock_movements', null],
  [/^\/observations(\/|$)/, 'trips', null],
  [/^\/finance(\/|$)/, 'finance_cockpit', FINANCE],
  // Une panne peut être déclarée par le chauffeur lui-même.
  [/^\/maintenance\/breakdowns$/, 'maintenance', [...PARC, 'CHAUFFEUR']],
  [/^\/maintenance(\/|$)/, 'maintenance', PARC],
  [/^\/invoices(\/|$)/, 'invoices', FACTURES],
  // Dossiers de manquants: le chauffeur peut répondre ou contester (voir dossiersManquants.js).
  [/^\/shortages(\/|$)/, 'volume_reconciliation', ['SUPER_ADMIN', 'ADMIN_SOCIETE', 'LOGISTIQUE', 'GESTIONNAIRE_STATION', 'CONTROLEUR_CARBURANT', 'CHAUFFEUR']],
  [/^\/documents(\/|$)/, 'documents', null],
];

export const MESSAGE_ROLE = 'Votre rôle ne permet pas cette action.';
export const MESSAGE_MODULE = 'Accès refusé: ce module ne fait pas partie de vos droits.';

const lireJson = (cle) => {
  try {
    return JSON.parse((typeof localStorage !== 'undefined' && localStorage.getItem(cle)) || 'null');
  } catch (erreur) {
    return null;
  }
};

const roleDuJeton = () => {
  try {
    const jeton = typeof localStorage !== 'undefined' ? localStorage.getItem('authToken') || localStorage.getItem('token') : null;
    return jeton ? JSON.parse(atob(jeton.split('.')[1])).role || null : null;
  } catch (erreur) {
    return null;
  }
};

/** Le rôle et les modules du compte connecté, tels que gardés sur l'appareil. */
export function identiteLocale() {
  const utilisateur = lireJson('app_v1_user') || lireJson('user');
  const role = utilisateur?.role || roleDuJeton();
  const modules = utilisateur?.entitlements?.enabled_modules || utilisateur?.license?.enabled_modules || null;
  return { role: role === 'ADMIN' ? 'ADMIN_SOCIETE' : role, modules };
}

/**
 * Pourquoi cette écriture est interdite au compte connecté, ou null si elle est permise.
 * Une identité inconnue (session jamais lue ici) ne bloque rien: le serveur tranchera au rejeu.
 */
export function refusLocal(chemin, identite = identiteLocale()) {
  const { role, modules } = identite;
  if (!role || role === 'SUPER_ADMIN') return null;
  const regle = REGLES.find(([motif]) => motif.test(chemin));
  if (!regle) return null;
  const [, module, roles] = regle;
  if (roles && !roles.includes(role)) return MESSAGE_ROLE;
  if (module && Array.isArray(modules) && !modules.includes(module)) return MESSAGE_MODULE;
  return null;
}

/** Refus décidé sur l'appareil, rendu à l'écran comme le serveur l'aurait rendu (422 / 403). */
export class RefusLocal extends Error {
  constructor(message, statut = 422, code = 'VALIDATION_ERROR') {
    super(message);
    this.statut = statut;
    this.code = code;
  }
}
